import React from "react"
import { ToggleButtonSeeker } from "@ui-seeker/core"
import { mergeDicts } from "@ui-seeker/utils"

import { dsColorNew } from "@palette"


// Segmented selector in the look of the app's pill toggle (same props and onChange as before)
export default function AppToggleButton({ buttonProps = {}, ...props }) {
	const { px, py, p, ...callerButtonSx } = buttonProps?.sx || {}

	return <ToggleButtonSeeker
		{...props}
		sx={mergeDicts({
			gap: '4px',
			p: '3px',
			borderRadius: '10px',
			backgroundColor: dsColorNew.pillTrackBg,
			border: `1px solid ${dsColorNew.grayBorder}`,
			'& .MuiToggleButtonGroup-grouped': { m: 0, border: '1.5px solid transparent !important', borderRadius: '8px !important' },
			'& .MuiToggleButtonGroup-grouped.Mui-selected': { borderColor: `${dsColorNew.appBlue} !important` },
		}, props?.sx || {})}
		buttonProps={{
			...buttonProps,
			sx: {
				px: '14px',
				py: '6px',
				textTransform: 'none',
				fontSize: 13,
				fontWeight: 500,
				lineHeight: 1.2,
				whiteSpace: 'nowrap',
				color: dsColorNew.textMuted,
				'&:hover': { backgroundColor: dsColorNew.white },
				...callerButtonSx,
				"&.Mui-selected, &.Mui-selected:hover": {
					color: dsColorNew.appBlue,
					fontWeight: 600,
					backgroundColor: dsColorNew.pillActiveBg,
				},
			},
		}}
	/>
}
